import { render, staticRenderFns } from "./denglong.vue?vue&type=template&id=31a1a2ae&scoped=true&"
import script from "./denglong.vue?vue&type=script&lang=js&"
export * from "./denglong.vue?vue&type=script&lang=js&"
import style0 from "./denglong.vue?vue&type=style&index=0&id=31a1a2ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a1a2ae",
  null
  
)

export default component.exports